import { DateTime } from 'luxon';

export const MAX_YEAR_ALLOWED = 2200;

export const getISOFormattedDate = (date: string): string => {
  return DateTime.fromISO(date).toFormat('LL-dd-yyyy');
};

export const displayDate = (date: string, format: string = 'MMM dd, yyyy') =>
  DateTime.fromISO(date).toFormat(format);

export const isToday = (date: string) =>
  DateTime.now().toISODate() === DateTime.fromISO(date).toISODate();
